import { erpAxios } from '..';

const searchNotifikacije = async (text, officerId, checked) => {
  const { data } = await erpAxios(`/sistemskeNotifikacije/search/${text}/${officerId}/${checked}`);
  return data;
};

export default searchNotifikacije;
